'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCurrency = exports.CURRENCY_USD = exports.CURRENCY_EUR = exports.CURRENCY_GBP = exports.DYZIO_CURRENCIES = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _countryData = require('country-data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DYZIO_CURRENCIES = exports.DYZIO_CURRENCIES = [{ key: 'GBP', text: '£ - British Pound', value: 'GBP' }, { key: 'USD', text: '$ - US Dollar', value: 'USD' }, { key: 'EUR', text: '€ - Euro', value: 'EUR' }];

var CURRENCY_GBP = exports.CURRENCY_GBP = 'GBP';
var CURRENCY_EUR = exports.CURRENCY_EUR = 'EUR';
var CURRENCY_USD = exports.CURRENCY_USD = 'USD';

var renderCurrency = exports.renderCurrency = function renderCurrency(code) {
  var currency = _lodash2.default.find(_countryData.currencies.all, ['code', code]);
  return currency ? currency.symbol : '£';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/utils/currencies.js
// module id = 266
// module chunks = 1